<template>
  <div class="container mx-auto text-sm max-w-5xl pb-10">
    <h1 class="text-2xl font-bold mb-6 text-center">Правила публикации объявлений</h1>

    <ul class="list-disc list-inside ml-4 space-y-2">
      <li>Не размещайте одно и то же объявление дважды.</li>
      <li>Цену за аренду указывайте в рублях РФ.</li>
      <li>Размер залога не желательно устанавливать выше 30% от текущей рыночной стоимости вещи.</li>
      <li>Название объявления должно соответствовать описанию вещи.</li>
      <li>В названии объявления должно быть название товара, модель и важные параметры, всё остальное указывается в описании.</li>
      <li>Не пишите цену товара в названии объявления — для этого есть отдельное поле.</li>
      <li>Название объявления должно быть на русском языке. Запрещено необоснованное использование заглавных букв, специальных символов, иностранного языка и слов, привлекающих внимание («Срочно», «Внимание» и «Аренда»).</li>
      <li>Описание объявления должно быть также на русском языке, не используйте иностранные языки и транслит. Необоснованное использование в описании объявления заглавных букв и специальных символов также недопустимо.</li>
      <li>Мы рекомендуем в разделе Описание отображать максимум полезной информации о вещи, так ваше объявление будет выглядеть привлекательнее по отношению к другим вещам.</li>
      <li>Выбирайте для объявления наиболее подходящую категорию, подкатегорию и дополнительные параметры (если имеются). Если вы не нашли подходящую подкатегорию — используйте «Другое».</li>
      <li>Указывайте реальные параметры вещи в объявлении. Если необходимо, используйте поля «Характеристика» и «Комплектация».</li>
      <li>Вся информация в объявлении должна соответствовать действительности.</li>
      <li>Используйте уникальные фотографии вещи, сделанные вами. Не допускается использование на фотографиях любой контактной информации, логотипов компаний, названий организаций и водяных знаков (вотермарков, водяных меток). Не добавляйте логотипы и названия компаний и организаций.</li>
      <li>Не допускается обработка изображений в специальных редакторах (добавление цветной рамки, заливка фона, размещение текста поверх изображения товара и пр.).</li>
      <li>Не указывайте вашу контактную информацию в описании или на фото — для этого есть поля в вашем профиле.</li>
      <li>Не размещайте объявлений, которые выходят за пределы концепции нашего сообщества (объекты недвижимости, предметы личной гигиены и др.).</li>
      <li>Объявление должно содержать описание только одного товара. Подача объявлений общего рекламного характера запрещена.</li>
      <li>Запрещено размещение объявлений, содержащих рекламную информацию, а также объявлений о рекламе интернет-ресурсов (порталы, форумы, сайты знакомств и т.д.) и бизнеса (магазинов, компаний). Признаки рекламного объявления: перечисление ассортимента товаров и цен.</li>
      <li>Размещайте объявления только о сдаче в аренду/аренде и возможной последующей продаже вещи.</li>
      <li>В объявлении или имени пользователя не допускается наличие эротического, порнографического, нецензурного, экстремистского или иного, не соответствующего политике сообщества POLKA, содержания.</li>
      <li>Не используйте программы для подачи и автозагрузки объявлений без разрешения администрации сообщества.</li>
      <li>Запрещено размещение объявлений, относящихся к Запрещенным сообществом, согласно Приложения №5 договора оферты</li>
      <li>Запрещено несанкционированное/необоснованное использование в объявлении или в имени пользователя логотипов и товарных знаков известных брендов.</li>
    </ul>

    <div class="text-center text-lg font-bold my-10">
      POLKA оставляет за собой право на дополнение и обновление существующих правил. Если у вас есть пожелание или вы нашли неточность - сообщите нам:
    </div>
    <SharedRmLink
      to="https://polka.rent/ru/lots/new"
      target="_blank"
      color="blue"
      class="px-4 rounded-md max-w-screen-sm mx-auto w-full block text-center text-lg py-4"
    >
      Сдать в аренду
    </SharedRmLink>

    <SharedFeedbackForm />


  </div>
</template>

<script setup>
useHead({
  title: 'Правила публикации объявлений',
  meta: [
    { name: 'description', content: 'Правила размещения объявлений на POLKA. Важные требования и рекомендации для успешной публикации ваших арендных предложений.' },
  ],
})
</script>

<style lang="scss" scoped></style>
